import React from 'react';
import Styles from "../../css";

const AppInfo = () => {
    const containerStyle = {
        textAlign: 'center',
        padding: '20px',
        ...Styles.fonts.commonFont,
        direction: 'rtl' // Changed to RTL for Hebrew
    };

    const headingStyle = {
        ...Styles.fonts.title,
        fontSize: '30px',
        marginBottom: '20px'
    };

    return (
        <div style={containerStyle}>
             <div style={headingStyle}>מערכת DCat</div>
             <p>כלי מקיף לניהול ועדות משמעת וערעורים בבתי ספר.</p>
             <br/>
             <p>לרכישת רישיון עבור בית הספר שלך, אנא צור קשר:</p>
             <p>
                 <strong>שם:</strong> גור תלם<br/>
                 <strong>אימייל:</strong> <a href="mailto:dcat@gtelem.com">dcat@gtelem.com</a>
             </p>

             <div style={{ marginTop: '30px' }}>
                <a href="/" style={{ textDecoration: 'none', fontSize: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: Styles.colors.black }}>
                    <span className="glyphicon glyphicon-home" style={{ fontSize: '24px', marginLeft: '10px' }}></span>
                    <span>חזרה לדף הבית</span>
                </a>
             </div>
        </div>
    );
};

export default AppInfo;
